package com.islamicmedia.shared.platform

actual fun getPushToken(): String? = null // Web doesn't use push notifications
actual fun getPushPlatform(): String = "web"
